import React, { useState } from "react";
import { FormStep, TextInput, CardLabel, Toast, SearchIcon, SubmitBar } from "@egovernments/digit-ui-react-components";
import Timeline from "../../components/Timeline";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel";

const ProfessionalDetails = ({ t, onSelect, formData, currStep }) => {
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const userInfo = Digit.UserService.getUser();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategory, setOwnershipCategory] = useState(formData?.owners?.ownershipCategory);
  const [name, setName] = useState(formData[currStep.key]?.name || "");
  const [registrationNumber, setregistrationNo] = useState(formData[currStep.key]?.registrationNumber || "");
  const [emailId, setemailId] = useState(formData[currStep.key]?.emailId || "");
  const [address, setaddress] = useState(formData[currStep.key]?.address || "");
  const [district, setDistrict] = useState(formData[currStep.key]?.district || "");
  const [state, setState] = useState(formData[currStep.key]?.state || "");
  const [mobileNumber, setMobileNumber] = useState(formData[currStep.key]?.mobileNumber || "");
  const [tehsil, setTehsil] = useState(formData[currStep.key]?.tehsil || "")
  const [town, setTown] = useState(formData[currStep.key]?.town || "")
  const [pinNo, setPinNo] = useState(formData[currStep.key]?.pinNo || "")
  const [classCat, setClassCat] = useState(formData[currStep.key]?.classA || "")
  const [university, setUniversity] = useState(formData[currStep.key]?.university || "")
  const [ername, setErName] = useState(formData[currStep.key]?.ername || "");
  const [erregistrationNumber, setErregistrationNo] = useState(formData[currStep.key]?.erregistrationNumber || "");
  const [eremailId, setEremailId] = useState(formData[currStep.key]?.eremailId || "");
  const [eraddress, setEraddress] = useState(formData[currStep.key]?.eraddress || "");
  const [erdistrict, setErDistrict] = useState(formData[currStep.key]?.erdistrict || "");
  const [erstate, setErState] = useState(formData[currStep.key]?.erstate || "");
  const [ermobileNumber, setErMobileNumber] = useState(formData[currStep.key]?.ermobileNumber || "");
  const [ertehsil, setErTehsil] = useState(formData[currStep.key]?.ertehsil || "")
  const [ertown, setErTown] = useState(formData[currStep.key]?.ertown || "")
  const [erpinNo, setErPinNo] = useState(formData[currStep.key]?.erpinNo || "")
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [error, setError] = useState(null);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory?.code.includes("MULTIPLEOWNERS") ? true : false;
  formData?.owners?.owners?.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false
  })
  const getFormEntries = (filter) => (
    (
      typeof formData[currStep.key] === 'object' &&
      !Array.isArray(formData[currStep.key])
    ) ?
      [Object.keys(formData[currStep.key])
        .filter((key) => filter(key))
        .reduce((obj, key) => {
          obj[key] = formData[currStep.key][key];
          return obj;
        }, {})] : null
  );
  const [fields, setFeilds] = useState(
    getFormEntries((key) => !key.startsWith('er')) || [{
      mobileNumber: userInfo?.info?.mobileNumber || "",
      name: userInfo?.info?.name || "",
      registrationNumber: "",
      emailId: userInfo?.info?.emailId || "",
      address: "",
      state: "",
      district: "",
      tehsil: "",
      town: "",
      pinNo: "",
      classA: "",
      university: ""
    }]
  );
  const [erfields, setErFeilds] = useState(
    getFormEntries((key) => key.startsWith('er')) || [{
      ermobileNumber: null,
      ername: "",
      erregistrationNumber: "",
      eremailId: "",
      eraddress: "",
      erstate: "",
      erdistrict: "",
      ertehsil: "",
      ertown: "",
      erpinNo: "",
    }]
  );
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErOwnerName(i, e) {
    let units = [...erfields];
    units[i].name = e.target.value;
    setErName(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setRegistrationNo(i, e) {
    let units = [...fields];
    units[i].registrationNumber = e.target.value;
    setregistrationNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErRegistrationNo(i, e) {
    let units = [...erfields];
    units[i].registrationNumber = e.target.value;
    setErregistrationNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setAddress(i, e) {
    let units = [...fields];
    units[i].address = e.target.value;
    setaddress(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErAddress(i, e) {
    let units = [...erfields];
    units[i].address = e.target.value;
    setEraddress(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErEmail(i, e) {
    let units = [...erfields];
    units[i].emailId = e.target.value;
    setEremailId(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectDistrict(i, e) {
    let units = [...fields];
    units[i].district = e.target.value;
    setDistrict(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErDistrict(i, e) {
    let units = [...erfields];
    units[i].district = e.target.value;
    setErDistrict(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTehsil(i, e) {
    let units = [...fields];
    units[i].tehsil = e.target.value;
    setTehsil(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTehsil(i, e) {
    let units = [...erfields];
    units[i].tehsil = e.target.value;
    setErTehsil(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTown(i, e) {
    let units = [...fields];
    units[i].town = e.target.value;
    setTown(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTown(i, e) {
    let units = [...erfields];
    units[i].town = e.target.value;
    setErTown(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectPinNO(i, e) {
    let units = [...fields];
    units[i].pinNo = e.target.value;
    setPinNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErPinNO(i, e) {
    let units = [...erfields];
    units[i].pinNo = e.target.value;
    setErPinNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }

  function selectClassCat(i, e) {
    let units = [...fields];
    units[i].classA = e.target.value;
    setClassCat(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectUniversity(i, e) {
    let units = [...fields];
    units[i].university = e.target.value;
    setUniversity(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }


  function selectState(i, e) {
    let units = [...fields];
    units[i].state = e.target.value;
    setState(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErState(i, e) {
    let units = [...erfields];
    units[i].state = e.target.value;
    setErState(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }

  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErMobileNo(i, e) {
    let units = [...erfields];
    units[i].mobileNumber = e.target.value;
    setErMobileNumber(e.target.value);
    setErFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }

  /////////////Viresh Doc 07-11-2023//////////////
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    const professionaldetail = {}
    professionaldetail.registrationNumber = registrationNumber || "";
    professionaldetail.name = name || ""
    professionaldetail.mobileNumber = mobileNumber || ""
    professionaldetail.address = address || ""
    professionaldetail.state = state || "";
    professionaldetail.district = district || ""
    professionaldetail.tehsil = tehsil || ""
    professionaldetail.town = town || "";
    professionaldetail.pinNo = pinNo || ""
    professionaldetail.emailId = emailId || ""
    professionaldetail.classA = classCat || "";
    professionaldetail.university = university || ""
    professionaldetail.erregistrationNumber = erregistrationNumber || ""
    professionaldetail.ername = ername || ""
    professionaldetail.ermobileNumber = ermobileNumber || ""
    professionaldetail.eraddress = eraddress || ""
    professionaldetail.erstate = erstate || "";
    professionaldetail.erdistrict = erdistrict || ""
    professionaldetail.ertehsil = ertehsil || ""
    professionaldetail.ertown = ertown || "";
    professionaldetail.erpinNo = erpinNo || ""
    professionaldetail.eremailId = eremailId || ""

    if (currentTab == "1") {
      setCurrentTab("2")
      return;
    }
    onSelect(currStep.key, professionaldetail);
  };
  const onSkip = () => onSelect();

  return (
    <div>
      <Timeline currentStep={currStep.step} flow="Form11" />
      <FormStep onSelect={goNext} onSkip={onSkip}
        t={t}
        isDisabled={canmovenext || isDisable} forcedError={t(error)}
        cardStyle={{ margin: '1.25rem auto 2rem' }}
      >
        <Tabs value={currentTab} onChange={handleChange}>
          {currStep.tabList.map((tab, index) => (
            <Tab label={`${t(tab)}`} value={`${index + 1}`} sx={{ textTransform: 'none', p: '0 1rem' }} />
          ))}
        </Tabs>
        <TabPanel value={currentTab} index="1" sx={{ p: 0 }}>
          {fields.map((field, index) => {
            return (
              <div key={`${field}-${index}`}>
                <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0", marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                  <CardLabel style={{ marginBottom: "-15px" }}>{`${t("CORE_COMMON_MOBILE_NUMBER")} *`}</CardLabel>
                  <div style={{ marginTop: "30px" }}>
                    <div className="field-container">
                      <div style={{ position: "relative", zIndex: "100", left: "35px", marginTop: "-24.5px", marginLeft: Webview ? "-25px" : "-25px" }}>+91</div>
                      <TextInput
                        style={{ background: "#FAFAFA", padding: "0px 35px" }}
                        type={"text"}
                        t={t}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="mobileNumber"
                        value={field.mobileNumber}
                        onChange={(e) => setMobileNo(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "[6-9]{1}[0-9]{9}",
                          type: "tel",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <div style={{ position: "relative", zIndex: "100", right: "35px", marginTop: "-24px", marginRight: Webview ? "-20px" : "-20px" }} onClick={(e) => getOwnerDetails(index, e)}> <SearchIcon /> </div>
                    </div>
                  </div>
                  <CardLabel>{`${t("CORE_COMMON_NAME")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="name"
                    value={field.name}
                    onChange={(e) => setOwnerName(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_REGISTRATION_NUMBER")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="registrationNumber"
                    value={field.registrationNumber}
                    onChange={(e) => setRegistrationNo(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{t("BPA_APPLICANT_EMAIL_LABEL") + "*"}</CardLabel>
                  <TextInput
                    t={t}
                    type={"email"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="emailId"
                    value={field.emailId}
                    onChange={(e) => selectEmail(index, e)}
                    //disable={editScreen}
                    {...{ required: true, pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", type: "email", title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID") }}
                  />
                  <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="registrationNumber"
                    value={field.address}
                    onChange={(e) => setAddress(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="state"
                    value={field.state}
                    onChange={(e) => selectState(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />

                  <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="district"
                    value={field.district}
                    onChange={(e) => selectDistrict(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />

                  <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="tehsil"
                    value={field.tehsil}
                    onChange={(e) => selectTehsil(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}

                  />
                  <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="town"
                    value={field.town}
                    onChange={(e) => selectTown(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="pinNo"
                    value={field.pinNo}
                    onChange={(e) => selectPinNO(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_CLASS_CATEGORIES")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="classA"
                    value={field.classA}
                    onChange={(e) => selectClassCat(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_UNIVERSITY_NAME")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="university"
                    value={field.university}
                    onChange={(e) => selectUniversity(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                </div>
              </div>
            );
          })}

        </TabPanel>
        <TabPanel value={currentTab} index="2" sx={{ p: 0 }}>

          {erfields.map((field, index) => {
            return (
              <div key={`${field}-${index}`}>
                <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0", marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                  <CardLabel style={{ marginBottom: "-15px" }}>{`${t("CORE_COMMON_MOBILE_NUMBER")} *`}</CardLabel>
                  <div style={{ marginTop: "30px" }}>
                    <div className="field-container">
                      <div style={{ position: "relative", zIndex: "100", left: "35px", marginTop: "-24.5px", marginLeft: Webview ? "-25px" : "-25px" }}>+91</div>
                      <TextInput
                        style={{ background: "#FAFAFA", padding: "0px 35px" }}
                        type={"text"}
                        t={t}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="ermobileNumber"
                        value={field.ermobileNumber}
                        onChange={(e) => setErMobileNo(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "[6-9]{1}[0-9]{9}",
                          type: "tel",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <div style={{ position: "relative", zIndex: "100", right: "35px", marginTop: "-24px", marginRight: Webview ? "-20px" : "-20px" }} onClick={(e) => getOwnerDetails(index, e)}> <SearchIcon /> </div>
                    </div>
                  </div>
                  <CardLabel>{`${t("CORE_COMMON_NAME")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="ername"
                    defaultValue={field.ername}
                    onChange={(e) => setErOwnerName(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_REGISTRATION_NUMBER")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="erregistrationNumber"
                    defaultValue={field.erregistrationNumber}
                    onChange={(e) => setErRegistrationNo(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{t("BPA_APPLICANT_EMAIL_LABEL") + "*"}</CardLabel>
                  <TextInput
                    t={t}
                    type={"email"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="eremail"
                    defaultValue={field.eremailId}
                    onChange={(e) => selectErEmail(index, e)}
                    //disable={editScreen}
                    {...{ required: true, pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", type: "email", title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID") }}
                  />
                  <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="eraddress"
                    defaultValue={field.eraddress}
                    onChange={(e) => setErAddress(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="erstate"
                    defaultValue={field.erstate}
                    onChange={(e) => selectErState(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />

                  <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="erdistrict"
                    defaultValue={field.erdistrict}
                    onChange={(e) => selectErDistrict(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />

                  <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="ertehsil"
                    defaultValue={field.ertehsil}
                    onChange={(e) => selectErTehsil(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}

                  />
                  <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="ertown"
                    defaultValue={field.ertown}
                    onChange={(e) => selectErTown(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="erpinNo"
                    defaultValue={field.erpinNo}
                    onChange={(e) => selectErPinNO(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                </div>
              </div>
            );
          })}



        </TabPanel>
        <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={goNext} />
      </FormStep>
      {showToast && <Toast
        error={showToast?.error}
        warning={showToast?.warning}
        label={t(showToast?.message)}
        isDleteBtn={true}
        onClose={closeToast}
      />
      }
    </div>
  );
};

export default ProfessionalDetails;
